import React from "react"
import { IUIUser } from "../../../models"
import strings from "../../../localization/strings"
import { IconButton, FontIcon } from "material-ui"
import { grey500 } from "material-ui/styles/colors"
import GlobalPunchEmployeeInfoDialog from "./GlobalPunchEmployeeInfoDialog"
interface IProps {
    style?: React.CSSProperties
    globalPunchEmployees: IUIUser[]
}
interface IState {
    openInfomationDialog: boolean
}

export default class GlobalPunchEmployeesInfoHoverIcon extends React.Component<IProps, IState>  {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openInfomationDialog: false
        }
    }
    render() {
        return (
            <div style={this.props.style}>
                <span style={{ fontSize: 16 }}>{`${this.props.globalPunchEmployees.length} ${strings.Selected_Employees}`}</span>
                <IconButton
                    style={{ height: 20, width: 20, padding: 0, top: 1 }}
                    iconStyle={{ fontSize: 16, color: grey500 }}
                    onTouchTap={() => this.setState({ openInfomationDialog: !this.state.openInfomationDialog })}
                >
                    <FontIcon className="fa fa-info-circle" />
                </IconButton>
                {this.state.openInfomationDialog &&
                    <GlobalPunchEmployeeInfoDialog
                        globalPunchEmployees={this.props.globalPunchEmployees}
                        handleClose={() => this.setState({ openInfomationDialog: false })}
                    />
                }
            </div>
        )
    }
}





